import { useEffect, MutableRefObject } from 'react';

function useResetScroll(
  ref: MutableRefObject<HTMLDivElement | null>,
  isOpen: boolean,
  resetPosition = { top: 0, left: 0 }
) {
  useEffect(() => {
    if (ref?.current && isOpen) {
      ref.current.scrollTo(resetPosition);
    }
  }, [isOpen]);
}

export default useResetScroll;
